// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3FEjp","rootCenter":"LoadMoreObserver_rootCenter__3GMQl","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1-De0"};